import type { PriceId } from '@iheartjane/types';

import { maybeParseFloat } from './maybeParseFloat';
import type { WeightPriced } from './weightPriced';

export function parsePriceAtPriceId(
  menuProduct: WeightPriced,
  priceId: PriceId,
  discounted = false
): number | undefined {
  const pricePrefix = discounted ? 'discounted_price_' : 'price_';
  return maybeParseFloat(menuProduct[`${pricePrefix}${priceId}`]);
}

export function lowestPriceForMenuProduct(
  menuProduct: WeightPriced,
  availableWeights: PriceId[]
) {
  let lowestPriceId = availableWeights[0];
  let lowestMenuProductPrice =
    parsePriceAtPriceId(menuProduct, availableWeights[0]) ?? Infinity;

  availableWeights.forEach((priceId) => {
    const pricesAtWeight = [
      parsePriceAtPriceId(menuProduct, priceId),
      parsePriceAtPriceId(menuProduct, priceId, true),
    ].filter((price): price is number => price !== undefined);
    const lowestPriceAtWeight = Math.min(...pricesAtWeight);

    if (lowestPriceAtWeight < lowestMenuProductPrice) {
      lowestPriceId = priceId;
      lowestMenuProductPrice = lowestPriceAtWeight;
    }
  });

  return lowestPriceId;
}
